export default __webpack_public_path__ + "static/media/circle-icon.1c2d4654.svg";